@if (!loading && centro) {
  <app-breadcrumb
    listado="/main/emergencias/centrosAtencion/medica"
    etiquetaListado="Bases de operaciones"
    [titulo]="centro?.identificacion"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas del detalle -->
  <header class="encabezado">
    <div class="encabezado-avatar"><mat-icon>apartment</mat-icon></div>
    <div class="encabezado-texto">
      <h1>{{ centro.identificacion || 'Base de operaciones' }}</h1>
      <div class="encabezado-chips">
        @if (centro.valores?.activo) {
          <span class="chip estado-ok">Activa</span>
        } @else {
          <span class="chip">Inactiva</span>
        }
        @if (cliente) {
          <span class="chip">
            <mat-icon>business</mat-icon>
            {{ cliente }}
          </span>
        }
      </div>
    </div>
    @if (puedeEditar) {
      <button
        irxBotonIcono
        class="encabezado-editar"
        (click)="editar()"
        tooltip="Editar base de operaciones"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </header>

  <!-- Una sola vista: sin pestañas -->
  <div class="detalle-cuerpo">
    <div class="em-grilla">
      <app-dt-card titulo="Datos" icono="apartment">
        <app-dt-datos>
          <app-dt-dato etiqueta="Radio de cobertura" [valor]="radio" />
          <app-dt-dato
            etiqueta="Teléfono"
            [valor]="centro.valores?.telefono"
            copiable
          />
          <app-dt-dato
            etiqueta="Email"
            [valor]="centro.valores?.email"
            copiable
          />
          <app-dt-dato etiqueta="Dirección" [valor]="centro.direccion" />
          <app-dt-dato etiqueta="Fecha de alta" [valor]="fechaAlta" />
        </app-dt-datos>
      </app-dt-card>

      @if (mapCardConfig) {
        <app-map-card [config]="mapCardConfig" height="440px"></app-map-card>
      } @else {
        <app-dt-card titulo="Ubicación" icono="location_on">
          <span class="dt-muted">
            Sin ubicación cargada. Editá la base para ubicarla en el mapa.
          </span>
        </app-dt-card>
      }
    </div>
  </div>
} @else if (!loading) {
  <app-breadcrumb
    listado="/main/emergencias/centrosAtencion/medica"
    etiquetaListado="Bases de operaciones"
    [titulo]="centro?.identificacion"
  ></app-breadcrumb>
  <app-empty-state
    icon="apartment"
    message="No se encontró la base de operaciones"
  ></app-empty-state>
} @else {
  <app-detalle-esqueleto
    icono="apartment"
    listado="/main/emergencias/centrosAtencion/medica"
    etiquetaListado="Bases de operaciones"
    [pestanas]="0"
  ></app-detalle-esqueleto>
}
